import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import check from "../../check.png";
import edit from "../../edit.png";



import InputText from "../../helpers/InputText";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPostCode from "../../helpers/InputPostCode";
import InputEmail from "../../helpers/InputEmail";
import InputPhone from "../../helpers/InputPhone";
import InputUploader from "../../helpers/InputUploader";
import InputTime from "../../helpers/InputTime";
import InputNIP from "../../helpers/InputNIP";
import InputREGON from "../../helpers/InputREGON";
import InputDecimal from "../../helpers/InputDecimal";
import InputUsername from "../../helpers/InputUsername";
import InputChecbox from "../../helpers/InputCheckbox";
import InputPassword from "../../helpers/InputPassword";
import InputCombo from "../../helpers/InputCombo";


function DirectorNew(props)
{

   

 
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [plgr, setPlGr] = useState(null);


    const [row, setRow] = useState({
        imie:  "",
        nazwisko: "",
        e_mail_kontakt: "",
        telefon_kontaktowy: "",
        haslo: "",
        moje_haslo: "",
        pl_wlasciciel: 0,
        pl: [],
    });
    var tmpRow = row;


    const getDataPlGr = () => {
       
 
        var req = {
        
        };

        fetch( Config.url + '/rest_v1,places_groups', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    setPlGr(res); 
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }


    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
              //  console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


   
    const valChangeListener = (filedName, val, correct, msg) => {

     //   console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        var tabCheck = filedName.split('@');
        if(tabCheck.length == 2)
        {
            var tabName = tabCheck[0];
            var tabInx  = tabCheck[1];
            var tRef = row[tabName];
            if(correct)tRef[tabInx] = val;
            if(!correct)tRef[tabInx] = "";

            tmpRow[tabName] = tRef;     
            setRow(  JSON.parse(JSON.stringify(tmpRow)) );  


           // console.log("EEEEEEEE", tmpRow );
            //setRow( {...row, [tabName]:tRef } );   
            return;
        }

       // setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );  
        
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
    }   


 


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const saveData = () => {


      
        

        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

        if(row.moje_haslo.length < 8)
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Podaj aktualne hasło do panelu" ,  "ok"  ,null); 
                return;
            }
    
            if(row.imie.length < 2)
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Podaj imię" ,  "ok"  ,null); 
                    return;
                }
    
    
            if(row.nazwisko.length < 2)
                    {
                        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Podaj nazwisko" ,  "ok"  ,null); 
                        return;
                    }    
    
     
            if(row.e_mail_kontakt.length < 4)
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Podaj e-mail" ,  "ok"  ,null); 
                    return;
                }   
    
            if(row.telefon_kontaktowy.length < 9)
                    {
                        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Podaj telefon" ,  "ok"  ,null); 
                        return;
                    }               
    

            var anyPLSelected = false;
            for(var kp=0; kp < row.pl.length ; kp++)
            {
                        console.log("PL ", kp, row.pl[kp] );
                        if(row.pl[kp] != undefined  &&   row.pl[kp].length > 0 ) anyPLSelected = true;
           }
            
           if(!anyPLSelected)
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz minimum jedną placówkę, do której " + row.imie + " " + row.nazwisko + " ma mieć dostęp." ,  "ok"  ,null); 
                return;
            }
            


 
        props.mainView.showDialog("Potwierdź", "Potwierdź operacje kodem SMS:", "auth", (crypt)=>{
          
            ///--------
            if(crypt != null) 
                {
                         

                            props.mainView.setProgress(-2);


                            var req = row;
                            req["crypt"] = crypt;
                    
                            fetch( Config.url + '/rest_v1,director_add', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => {             
                                        
                                        props.mainView.setProgress(-1);
                    
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                        // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        setErrTab(res.result);
                                        }else
                                        if(res.status != undefined && res.status == "OK")
                                        {
                                            props.mainView.showDialog( "Sukces",  "Konto zostało dodane", "ok" , null);                        
                                        props.back();
                                        }else
                                        {
                                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                        }
                                    
                            } )
                            .catch(err => {   
                                        props.mainView.setProgress(-1);       
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                            });
                                


                }
            //--------
        }, "Nowe konto dyrektora: " + row.imie + " " + row.nazwisko );
 



      

         return false;

    }




    if(plgr == null)
    {   
        getDataPlGr();
        return (
            <div></div>
        );        
    }

  

    var items = [
        { v: '0', title: "Domyślny poziom uprawnień" },
        { v: '1', title: "Administrator (pełen dostęp)" },
    ];
 

    document.title = "Konto dyrektora " + row.nazwisko + " " + row.imie;


    return (
        <div className="view_content">
       
             
                  
              <form className="eForm bg_center">


              <div className="form_tab_title">Dane dyrektora:</div>
              <div className="form_tab">                            

                        <div className="form_control">
                            <div className="fieldName">Imię*</div>
                            <InputTextAlpha   userData={props.userData} value={row.imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię: "} className=' w200 ' req='1' firstUp="1" />
                        </div>

                        <div className="form_control">
                            <div className="fieldName">Nazwisko*</div>
                            <InputTextAlpha   userData={props.userData} value={row.nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko: "} className=' w200 ' req='1' firstUp="1" />
                        </div>

                    

                        
                        <div className="form_control">
                            <div className="fieldName">E-mail*</div>
                            <InputEmail    userData={props.userData} value={row.e_mail_kontakt} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="e_mail_kontakt" placeholder={ "E-mail: "} className=' w250' req='1' />
                        </div>

                        
                        <div className="form_control">
                            <div className="fieldName">Telefon*</div>
                            <InputPhone    userData={props.userData}  value={row.telefon_kontaktowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="telefon_kontaktowy" placeholder={"Telefon: "} className=' w100' req='1' />
                        </div>

                    </div>

                    <div className="form_split"></div>


                    <div className="form_tab_title">Autoryzacja</div>
                    <div className="form_tab">                           


                            <div className="form_control">
                                <div className="fieldName">Moje hasło do panelu, którym się loguje:</div>
                                <InputPassword    userData={props.userData}  value={row.moje_haslo}  err={errTab} valChange={valChangeListener} goNext={goNextNew} name="moje_haslo" placeholder={"Moje hasło do panelu: "} className=' w100' req='1' />
                            </div>

                            <div className="form_split"></div>
                            
                 

                            <div className="form_control">
                                <div className="fieldName">Login dyrektora</div>
                                <span><b>{row.e_mail_kontakt} </b></span>
                            </div>

                            <div className="form_split"></div>
                         
                            
                            <div className="form_control">
                                <div className="fieldName">Hasło (Min. 8 znaków, cyfry, litery małe i duże, znaki specjalne !@#...)*</div>
                                <InputPassword    userData={props.userData}  value={row.haslo}  err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="haslo" placeholder={"Hasło: "} className=' w100' req='1' rand="1" />
                        
                            </div>
                    </div>


                        <div className="form_tab_title">Dostęp do:</div>
                        <div className="form_tab">                   
                             
                                {
                                    plgr.result.map( (item, ix) => {                                        

                                         
                                            var ccc = false;

                                            for(var p=0; p<row.pl.length; p++)
                                            {
                                                if(row.pl[p] == item.id)      ccc = true;
                                            }

                                            return (
                                                <div className="form_control">                                                         
                                                       <InputChecbox  title={item.nazwa}  err={errTab}  userData={props.userData}  checked={ccc} value={item.id} valChange={valChangeListener}  name={ "pl@"+ix  }   className=' ' req='0' />
                                                </div>
                                            )

                                    } )
                                }


                                    {
                                        props.isRoot == 1 &&
                                        <Fragment>
                                                    <div className="form_split"></div>

                                                    <div className="form_control">
                                                                <div className="fieldName">*Poziom uprawnień</div>
                                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={items} value={row.pl_wlasciciel} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pl_wlasciciel" placeholder={":"} className='  ' req='1'   />
                                                                <br/>
                                                                <p>* Administrator - osoba, która ma dostęp do wszystkich zakładek systemu. Może zmieniać uprawnienia innym, śledzić historie zdarzeń, ma wgląd w płatności dla eLizak.edu.pl, ...  </p>
                                                    </div>
                                        </Fragment>
                                    }


                        </div>


                        <div className="form_split"></div>

                        <div className="form_btn">
                                <div className="btn" onClick={saveData}>dodaj</div>
                                &nbsp;&nbsp;
                                <div className="btn" onClick={props.back}    > anuluj</div>
                        </div>


              </form>

        </div>
    );


    

}


export default DirectorNew;